module.exports = __webpack_public_path__ + "img/parallel.1b2e8b04.svg";